import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const ViewJobSkill = ({ viewObj }) => {
  const [viewObjData, setViewObjData] = useState([]);

  useEffect(() => {
    if (viewObj) {
      setViewObjData(viewObj);
    }
  }, [viewObj]);

  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewReg"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "30%", maxWidth: "30%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">View Category</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Skill</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.skill}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Category</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.category}
                    readOnly
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    value={viewObjData?.description}
                    readOnly
                  />
                </div>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary d-flex ms-auto mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ViewJobSkill.propTypes = {
  viewObj: PropTypes.object.isRequired,
};

export default ViewJobSkill;
